
<template>
  <el-row :gutter="15">
    <el-col :span="24">
      <div v-loading="isLoading">
        <Filters
          class="mb-3"
          :resource="$sdk.carrier_service"
          :filters.sync="filters"
          @apply="reload"
          @ready="load"
        />
        <el-card shadow="never">
          <ServicesTable
            ref="contactTable"
            :services="services"
            @refresh="reload"
            @edit="edit"
          />
          <br>
          <div style="text-align: center;">
            <el-pagination
              :current-page.sync="services.page"
              :page-size.sync="services.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="services.total"
              @size-change="reload"
              @current-change="reload"
            />
          </div>
          <ServiceForm
            ref="ServiceForm"
            :service="service"
            @refresh="reload"
          />
        </el-card>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import ServicesTable from '@/components/Application/Manage/Carriers/ServicesTable'
import ServiceForm from '@/components/Application/Manage/Carriers/ServiceForm'
import Filters from '@/components/Filters/Complex'
import { CREATE } from '@/plugins/user'

export default {
  components: {
    ServicesTable,
    ServiceForm,
    Filters
  },
  data () {
    return {
      title: 'Carrier Services',
      pageTitle: 'Services',
      breadcrumb: {
        name: 'Services',
        route: { name: 'manage-carriers-carrier-services', params: { carrierId: this.$route.params.carrierId } }
      },
      actions: [
        {
          hidden: this.$user.cannot(CREATE, 'carrier_service'),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.showForm()
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => {
            this.reload()
          }
        }
      ],
      form: {
        allow_dg: false,
        chainit: null,
        code: null,
        con: null,
        config_itm_max_def: null,
        config_itm_min_def: null,
        config_itm_prefix_def: null,
        config_itm_prefix_req: false,
        default_cubic: null,
        edi: null,
        items_max: null,
        items_min: null,
        label: null,
        name: null,
        type: null,
        volume_max: null,
        volume_min: null,
        warn_chweight: null,
        warn_length: null,
        weight_max: null,
        weight_min: null,
        create: true,
        service_type: null
      },
      page: 1,
      perPage: 10,
      total: 0,
      sort: 'desc',
      isLoading: true,
      isSaving: false,
      services: [],
      editMode: false,
      service: {},
      filters: []
    }
  },
  methods: {
    load () {
      this.isLoading = true
      this.$sdk.carrier_service.list((builder) => {
        builder.context = { resource: 'carrier', id: this.$route.params.carrierId }
        builder.include = ['service_type', 'rules']
        builder.filters = this.filters
        builder.order = 'name:asc'
      }).then(res => {
        this.services = res
        this.reset()
      }).finally(() => { this.isLoading = false })
    },
    async reload () {
      try {
        this.isLoading = true
        await this.services.reload(builder => { builder.filters = this.filters })
      } catch {
        this.$message.error('An error occurred while loading the Services')
      } finally {
        this.isLoading = false
      }
    },
    showForm (row) {
      if (row) {
        this.$refs.ServiceForm.showDialog()
      } else {
        this.service = this.form
        this.$refs.ServiceForm.showDialog()
      }
    },
    edit (row) {
      this.service = row
      this.showForm(row)
    },
    reset () {
      this.form = {
        allow_dg: false,
        chainit: null,
        code: null,
        con: null,
        config_itm_max_def: null,
        config_itm_min_def: null,
        config_itm_prefix_def: null,
        config_itm_prefix_req: false,
        default_cubic: null,
        edi: null,
        items_max: null,
        items_min: null,
        label: null,
        name: null,
        type: null,
        volume_max: null,
        volume_min: null,
        warn_chweight: null,
        warn_length: null,
        weight_max: null,
        weight_min: null,
        create: true
      }
      this.service = {}
    }
  }
}
</script>
